import { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Divider, Stack, Grid, Typography } from '@mui/material';
import dayjs from 'dayjs';
import double_tick from '../../assets/svg/double_tick.svg';
import { UseStores } from '../../hooks/UseStores';

const DATE_FORMAT = 'MMM DD YYYY';

const CampaignSummary = () => {
  const { audience, mapstore, store } = UseStores();
  const [zipcodes, setZipcodes] = useState('');
  const [selectedDates, setSelectedDates] = useState('');

  useEffect(() => {
    if (mapstore.selectedZipCodeList) {
      const zipString = Object.keys(mapstore.selectedZipCodeList).join(', ');
      setZipcodes(zipString);
    }
  }, [mapstore.selectedZipCodeList]);

  useEffect(() => {
    if (store.selectedAvailability) {
      const week = `${dayjs(store.selectedAvailability.date_start).format(
        DATE_FORMAT,
      )} - ${dayjs(store.selectedAvailability.date_end).format(DATE_FORMAT)}`;
      setSelectedDates(week);
    }
  }, [store.selectedAvailability]);

  const renderCell = (label, value) => (
    <Grid container mt={2}>
      <Grid item xs={4}>
        <Typography variant="body1" display="block" gutterBottom>
          {label}
        </Typography>
      </Grid>
      <Grid item xs={8}>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          sx={{ textAlign: 'right' }}
        >
          {value}
        </Typography>
      </Grid>
    </Grid>
  );

  return (
    <Stack spacing={4} mt={4} mb={4}>
      <div style={{ textAlign: 'center' }}>
        <img
          src={double_tick}
          id="success_mark"
          alt="success_mark"
          width="8%"
          data-testid="success_mark_test"
        />
        <Typography variant="h5" display="block" gutterBottom>
          Thank you for submitting your campaign details & information. Our
          GroundTruth&apos;s team member will reach out to you shortly with next
          steps.
        </Typography>
      </div>
      <Stack spacing={2}>
        {renderCell(
          'Audience category selected',
          audience.selectedAudience.value,
        )}
        <Divider />
        {renderCell('Zip Codes', zipcodes)}
        <Divider />
        {renderCell('Total addresses', mapstore.totalAddresses)}
        <Divider />
        {renderCell('Selected campaign dates', selectedDates)}
      </Stack>
    </Stack>
  );
};

export default observer(CampaignSummary);
